import axios from "axios"
import authAxios from "./axios-instance/authAxios";

const mainApiHost = process.env.REACT_APP_MAIN_API_HOST;

export function ClickLogsApi(props) {
    return {
        count: async ({ body, headers }) => {
            return await authAxios.post(`${mainApiHost}/click-logs/count`, body, {
                headers: headers,
                withCredentials: true
            });
        },
        log: async ({ body, headers }) => {
            return await axios.post(`${mainApiHost}/click-logs/log`, body, {
                headers: headers
            });
        },
    }
}